// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__TSlEi","requiredAsterisk":"Info_requiredAsterisk__2PCSE"};